/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Ott-common */
import Button from '@dtvgo/button';
import Tooltip from '@dtvgo/tooltip';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableIconButton.scss';

function FocusableIconButton({
  children,
  primary,
  className,
  disabled,
  focused,
  icon,
  tooltipId,
  onMouseDown,
  onMouseEnter,
}) {
  return (
    <Button
      primary={primary}
      className={
      `dtv-html5-c-focusable-icon-button ${
        focused ? 'dtv-html5-c-focusable-icon-button--focused' : ''
      } ${className}`
    }
      disabled={disabled}
      icon={icon}
      classNameIcon="dtv-html5-c-focusable-icon-button__icon"
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      {children}
      {tooltipId && (
      <Tooltip placement="bottom" bgColor="transparent" className="dtv-html5-c-focusable-icon-button__tooltip">
        <FormattedMessage id={tooltipId} />
      </Tooltip>
      )}
    </Button>
  );
}

FocusableIconButton.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.bool,
  className: PropTypes.string,
  tooltipId: PropTypes.string,
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  icon: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

FocusableIconButton.defaultProps = {
  children: undefined,
  primary: false,
  className: '',
  tooltipId: '',
  disabled: false,
  focused: false,
  icon: '',
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

export default memo(withInteractiveFocusable()(memo(FocusableIconButton)));
